const copyToClipboard = async (value) => {
  await navigator.clipboard.writeText(value)
}

export { copyToClipboard }
